import { CommandBar, Button, Icon, Dropdown, Menu, MenuItem } from '../../workflows/WorkflowsScope';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../root-redux/RootState';
import { setWorkflowSummaryStatus } from '../../workflows/workflows-redux/Workflows.redux';
import { postWorkflow, postWorkflowReleaseManagement } from '../../../services/PostWorkflow.api';
import { addConnection, patchReleaseWorkflow, setReleaseWorkflowStatus } from '../ReleaseData.redux';
import { useEffect, useState } from 'react';
import { addRelease, setReleaseStatus } from '../Releases.redux';
import { ConnectionsCollection } from '../../../model/connections/ConnectionsCollection.model';
import { propagateConnectionReleaseManagement } from '../../../services/PropagateConnections.api';
import { Environment, Release } from '../../../model/releases/Release.model';
import { v4 as uuidv4 } from 'uuid';
import { postRelease, postReleaseReleaseManagement } from '../../../services/PostRelease.api';
import { publishWorkflow, publishWorkflowReleaseManagement } from '../../../services/PublishWorkflow.api';
import { unwrapResult } from '@reduxjs/toolkit';
import { prodReleasePermissionsSelector } from '../ReleaseRBAC.selectors.redux';
import { SuccessNotification } from '../../notifications/SuccessNotification';
import { ErrorNotification } from '../../notifications/ErrorNotification';
import { postInsightFamily, postInsightFamilyReleaseManagement } from '../../../services/PostInsightFamily.api';
import { withErrorBoundary } from '../../../shared-components/ErrorBoundary';
import { ModelMapping } from '../../../model/configModels/ModelMapping.model';
import { getModelMapping_uat } from '../../../services/GetModelMapping.api';
import { updateModelMapping_prod } from '../../../services/PostModelMapping.api';
import { TypeMappingObject } from '../../../model/configModels/TypeMappingObject.model';
import { updateTypeMapping_prod } from '../../../services/PostTypeMapping.api';
import { Schedule } from '../../../model/workflows/Schedule.model';
import { validateInsightFamily_prod } from '../../../services/ValidateInsightFamily.api';
import { EdmEntityTypeSettings } from '../../../model/apiConfig/EdmEntityTypeSettings.model';
import { getApiConfig_uat } from '../../../services/APIConfig/GetApiConig.api';
import { propagateRoute } from '../../../services/APIConfig/PropagateApiConfig.api';
import { MergeRule } from '../../../model/merge-rules/MergeRule.model';
import { getMergeRules_uat } from '../../../services/get-merge-rules/GetMergeRules.api';
import { propagateMergeRule_prod } from '../../../services/get-merge-rules/PropagateMergerule.api';
import { getCatalogueConfig_uat } from '../../../services/GetCatalogueConfig.api';
import { updateCatalogueConfig_prod } from '../../../services/PostCatalogueConfig.api';
import { getInsightId } from './ReleaseActionsUAT';
import { getPublishedMCPConfigById, propagateMCPConfig } from '../../../services/MCPConfig/MCPConfig.api';


export const handlePostRelease = (props:any) => {

  const environments: Environment[] = [
    { environment: "dev", isDeployed: false },
    { environment: "uat", isDeployed: false },
    { environment: "prod", isDeployed: true },
  ];

  const releaseData: Release = {
    environments: environments,
    timestamp: "",
    releaseId: props.releaseId,
    workflowId: props.workflowId,
    version: props.version,
    id: uuidv4().toString(),
    type: "Propagate",
    status: "Published",
    scheduleCreated: false
  };
  
  return releaseData;
};

export const handlePropagateConnections = (props:any) => {
  //IMPORTANT -> Here dev means lower environment and uat means higher environment!!
  const devConnections = props.devConnections;
  const uatConnections = props.uatConnections;
  const devWorkflow = props.devWorkflow;
  let connData : {type: string, id:string}[] = [];

  let dataIngestion = devWorkflow.dataIngestion;
  dataIngestion?.map((item: any) => {
    if (connData.findIndex((data) => data.id == item.connectionId) == -1) {
      connData.push({
        type: item.type,
        id: item.connectionId,
      });
    }
  });

  let delta = devWorkflow.delta;
  delta?.map((item:any) => {
    if (connData.findIndex((data) => data.id == item.connectionId) == -1) {
      connData.push({
        type: "BLOB",
        id: item.connectionId,
      });
    }
  });

  let publish = devWorkflow.publish;
    publish?.map((item:any) => {
      if(item.type != "SQL")
      {
        if (connData.findIndex((data) => data.id == item.connectionId) == -1) {
          connData.push({ type: item.type, id: item.connectionId });
        }
        if (connData.findIndex((data) => data.id == item.blobConnectionId) == -1) {
          connData.push({ type: "BLOB", id: item.blobConnectionId });
        }
      }
      else{
        if (connData.findIndex((data) => data.id == item.connectionId) == -1) {
          connData.push({ type: "BLOB",id: item.connectionId });
        }
      }
    });

    let connectionItemsUatFinal = {} as ConnectionsCollection

    Object.keys(devConnections).forEach((key: string) => {

      let connectionItemsDev = devConnections[key];
      let connectionItemsUat = uatConnections[key];
     
      connData.map((connDataItem) => {

        if(connectionItemsDev && connDataItem.id.length != 0 && connDataItem.type.length != 0)
        {
          if(connDataItem.type.toUpperCase() == "ADLS" || connDataItem.type.toUpperCase() == "ADLSGEN1")
        {
          const devData = connectionItemsDev.adlsConnections.find((data:any)=> data.connectionId == connDataItem?.id);
          const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined ? connectionItemsUat.adlsConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

            if(uatIndex > -1 && devData)
            {
                let updatedAdlsConn = [...connectionItemsUat.adlsConnections];
                updatedAdlsConn[uatIndex] = devData;
                connectionItemsUat = {...connectionItemsUat, adlsConnections: updatedAdlsConn};
            }
            else if (devData)
            { 
              if(connectionItemsUat != undefined )
                {
                  const totalConnections = connectionItemsUat.adlsConnections.length;
                  let updatedAdlsConn = [...connectionItemsUat.adlsConnections];
                  updatedAdlsConn[totalConnections] = devData;
                  connectionItemsUat = {...connectionItemsUat, adlsConnections: updatedAdlsConn};
                }
            }
        }
      }
      if(connDataItem.type.toUpperCase() == "BLOB")
      {
        const devData = connectionItemsDev.blobConnections.find((data:any)=> data.connectionId == connDataItem?.id);
        const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined ? connectionItemsUat.blobConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

          if(uatIndex > -1 && devData)
          {
            
              let updatedBlobConn = [...connectionItemsUat.blobConnections];
              updatedBlobConn[uatIndex] = devData;
              connectionItemsUat = {...connectionItemsUat, blobConnections: updatedBlobConn};
          }
          else if (devData)
          {
            if(connectionItemsUat != undefined)
            {
              const totalConnections = connectionItemsUat.blobConnections.length;
              let updatedBlobConn = [...connectionItemsUat.blobConnections];
              updatedBlobConn[totalConnections] = devData;
              connectionItemsUat = {...connectionItemsUat, blobConnections: updatedBlobConn};
            }
           
          }
      }


      if(connDataItem.type.toUpperCase() == "COSMOS")
      {
        const devData = connectionItemsDev.cosmosConnections.find((data:any)=> data.connectionId == connDataItem?.id);
        const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined? connectionItemsUat.cosmosConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

          if(uatIndex > -1 && devData)
          {
              let updatedCosmosConn = [...connectionItemsUat.cosmosConnections];
              updatedCosmosConn[uatIndex] = devData;
              connectionItemsUat = {...connectionItemsUat, cosmosConnections: updatedCosmosConn};
          }
          else if (devData)
          {
            if(connectionItemsUat != undefined)
            {
              const totalConnections = connectionItemsUat.cosmosConnections.length;
              let updatedCosmosConn = [...connectionItemsUat.cosmosConnections];
              updatedCosmosConn[totalConnections] = devData;
              connectionItemsUat = {...connectionItemsUat, cosmosConnections: updatedCosmosConn};
            }
          }
      }

      if(connDataItem.type.toUpperCase() == "API")
      {
        const devData = connectionItemsDev.apiConnections.find((data:any)=> data.connectionId == connDataItem?.id);
        const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined ? connectionItemsUat.apiConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

          if(uatIndex > -1 && devData)
          {
              let updatedApiConn = [...connectionItemsUat.apiConnections];
              updatedApiConn[uatIndex] = devData;
              connectionItemsUat = {...connectionItemsUat, apiConnections: updatedApiConn};
          }
          else if (devData)
          {
            if(connectionItemsUat != undefined)
            {
              const totalConnections = connectionItemsUat.apiConnections.length;
              let updatedApiConn = [...connectionItemsUat.apiConnections];
              updatedApiConn[totalConnections] = devData;
              connectionItemsUat = {...connectionItemsUat, apiConnections: updatedApiConn};
            }
          }
      }

      if(connDataItem.type.toUpperCase() == "SQL")
      {
        const devData = connectionItemsDev.sqlConnections.find((data:any)=> data.connectionId == connDataItem?.id);
        const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined ? connectionItemsUat.sqlConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

          if(uatIndex > -1 && devData)
          {
              let updatedSqlConn = [...connectionItemsUat.sqlConnections];
              updatedSqlConn[uatIndex] = devData;
              connectionItemsUat = {...connectionItemsUat, sqlConnections: updatedSqlConn};
          }
          else if (devData)
          {
            if(connectionItemsUat != undefined)
            {
              const totalConnections = connectionItemsUat.sqlConnections.length;
              let updatedSqlConn = [...connectionItemsUat.sqlConnections];
              updatedSqlConn[totalConnections] = devData;
              connectionItemsUat = {...connectionItemsUat, sqlConnections: updatedSqlConn};
            }
          }
      }

      if(connDataItem.type.toUpperCase() == "SQLAAD")
      {
        const devData = connectionItemsDev.sqlaadConnections.find((data:any)=> data.connectionId == connDataItem?.id);
        const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined ? connectionItemsUat.sqlaadConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

          if(uatIndex > -1 && devData)
          {
              let updatedSqlaadConn = [...connectionItemsUat.sqlaadConnections];
              updatedSqlaadConn[uatIndex] = devData;
              connectionItemsUat = {...connectionItemsUat, sqlaadConnections: updatedSqlaadConn};
          }
          else if (devData)
          {
            if(connectionItemsUat != undefined)
            {
              const totalConnections = connectionItemsUat.sqlaadConnections.length;
              let updatedSqlaadConn = [...connectionItemsUat.sqlaadConnections];
              updatedSqlaadConn[totalConnections] = devData;
              connectionItemsUat = {...connectionItemsUat, sqlaadConnections: updatedSqlaadConn};
            }
          }
      }

      if(connDataItem.type.toUpperCase() == "TOPIC")
      {
        const devData = connectionItemsDev.topicConnections.find((data:any)=> data.connectionId == connDataItem?.id);
        const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined ? connectionItemsUat.topicConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

          if(uatIndex > -1 && devData)
          {
              let updatedTopicConn = [...connectionItemsUat.topicConnections];
              updatedTopicConn[uatIndex] = devData;
              connectionItemsUat = {...connectionItemsUat, topicConnections: updatedTopicConn};
          }
          else if (devData)
          {
            if(connectionItemsUat != undefined )
            {
              const totalConnections = connectionItemsUat.topicConnections.length;
              let updatedTopicConn = [...connectionItemsUat.topicConnections];
              updatedTopicConn[totalConnections] = devData;
              connectionItemsUat = {...connectionItemsUat, topicConnections: updatedTopicConn};
            }
          }
      }

      if(connDataItem.type.toUpperCase() == "EVENT")
      {
        const devData = connectionItemsDev.eventConnections.find((data:any)=> data.connectionId == connDataItem?.id);
        const uatIndex = connectionItemsUat != null || connectionItemsUat != undefined ? connectionItemsUat.eventConnections.findIndex((data:any)=> data.connectionId == connDataItem?.id) : -1

          if(uatIndex > -1 && devData)
          {
              let updatedEventConn = [...connectionItemsUat.eventConnections];
              updatedEventConn[uatIndex] = devData;
              connectionItemsUat = {...connectionItemsUat, eventConnections: updatedEventConn};
          }
          else if (devData)
          {
            if(connectionItemsUat != undefined )
            {
              const totalConnections = connectionItemsUat.eventConnections.length;
              let updatedEventConn = [...connectionItemsUat.eventConnections];
              updatedEventConn[totalConnections] = devData;
              connectionItemsUat = {...connectionItemsUat, eventConnections: updatedEventConn};
            }
          }
      }

      connectionItemsUatFinal = connectionItemsUat;

      });
   });
   return connectionItemsUatFinal;

};

export const handlePropagateModelMapping = (props:any) => {

  var modelMapping_dev = props.modelMapping_dev;
  const devWorkflow = props.devWorkflow;
  const modelName = devWorkflow?.modelName;
  var modelId = "";

  var modelMappingItemToBePropagated = {} as ModelMapping;
  
  if(devWorkflow?.publish.length > 0)
  {
    modelId = devWorkflow?.publish[0].modelId;
    
    modelMapping_dev.map((modelmappingitem : ModelMapping)=>{
      if(modelmappingitem?.name == modelName || modelmappingitem?.id == modelId)
      {
        modelMappingItemToBePropagated = modelmappingitem;
      }
    });

  }
  
  return modelMappingItemToBePropagated;

}

export const handlePropagateTypeMapping = (props:any) => {

  const devWorkflow = props.devWorkflow;
  var family = devWorkflow.family;
  const selectedPublish = devWorkflow.publish.find((x:any) => x.type === 'COSMOS')
  const partitionKey = selectedPublish != null ? (selectedPublish?.publishMap.find((x:any) => x.destination === 'PartitionKey') != null ? selectedPublish?.publishMap.find((x:any) => x.destination === 'PartitionKey')?.source : '') : ''
  let typeMap = new Map<string, string>();
  let mapValues = null;
  if (family && partitionKey)
      typeMap.set(family, partitionKey);
  if (devWorkflow.workFlowType === "Insight" && partitionKey) {
      // This below entry is added as it maybe needed in some cases. since we are automating we cant predict
      // we can remove it if its not needed. This is based on current design
      typeMap.set(partitionKey, partitionKey);
  }
  if (typeMap.size > 0) mapValues = Object.fromEntries(typeMap);

  if (mapValues != null) {
      let typeMappingSchema: TypeMappingObject = {
          typeMapping: mapValues,
      };
      return typeMappingSchema;
  }
};
export const handlePropagateApiConfig = (props: any) => {
    var apiConfig = props.apiConfig_uat
    var routeName = props.routeName
    var family = props.workflow.family
    var workflowType = props.workflow.workFlowType
    var edmEntityTypeSettings: EdmEntityTypeSettings[] = []
    for (var setting of apiConfig.edmEntityTypeSettings) {
        if (workflowType === "Recommendation") {
            if (setting.routeName === routeName || setting.routeName === routeName + 'actions') {
                if (setting.type === family) {
                    edmEntityTypeSettings.push(setting)
                }
            }
        }
        else if (setting.routeName === routeName) {
            edmEntityTypeSettings.push(setting)
        }
    }
    return edmEntityTypeSettings;
};
export const handleDefaultMergeRulePropagation = (props: any) => {
  const devWorkflow = props.devWorkflow;
  const workflowname = props.workflowname;
  const mergerules_dev = props.mergerules_dev;
  const modelMapping_dev = props.modelMapping_dev;
  const modelId = devWorkflow?.publish[0].modelId;
  var modelname = ""; 
  var mergerRuleToBePropagated = {} as MergeRule;
  if(modelId)
  {
    modelMapping_dev.map((modelmappingitem : ModelMapping)=>{
      if(modelmappingitem?.id == modelId)
      {
        modelname = modelmappingitem?.name;
      }
    });
  }
 
  if (devWorkflow?.typeOfMerge == "Default") {

    const mergeruleName_prop =  "Default" + (modelname ? modelname : workflowname) + "MR";

    mergerules_dev?.data.map((item: MergeRule) => {
      if (item.mergeRuleName == mergeruleName_prop) {
        mergerRuleToBePropagated = item;
      }
    });
    
  }
  return mergerRuleToBePropagated;
};


const ReleaseActionsPRODC: React.FC<any> = (props: any) => {
  
  const userId = useSelector((state: RootState) => state.userDetails.localAccountId);
  const dispatch = useDispatch();
  const dispatchApp = useDispatch<AppDispatch>();
  const uatConnections = useSelector((state: RootState) => state.releaseData.uatConnections );
  const prodConnections = useSelector((state: RootState) => state.releaseData.prodConnections );
  const userSalesRoles = useSelector((state: RootState) => state.userSalesRoles);
  const catalogueConfig_uat = useSelector((state: RootState) => state.releaseData.catalogueConfig.uatCatalogueConfig);
  const uatWorkflow = props.uatWorkflow;
  const actionedVersion = props.selectedVersion;
  const subscriptionKey = props.subscriptionKey;
  const workflowId = props.workflowId;
  const releaseId = props.releaseId;
  const selectedReleaseIds = props.selectedReleaseIds;
  const uatAppPersona = useSelector((state: RootState) => state.releaseData.uatAppPersonas) ;
  const [prodApproveReject, setprodApproveReject] = useState(true);
  const [prodDeploy, setprodDeploy] = useState(true);
  const releaseRows = props.releaseRows;
  const [showErrorNotif, setShowErrorNotif] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [successText, setSuccessText] = useState("");
  const [showSuccessNotif, setShowSuccessNotif] = useState(false);
  const [insightWorkflow, setinsightWorkflow] = useState("Insight");
  const [familyName, setfamilyName] = useState("");
  const [insightFamilyExists, setinsightFamilyExists] = useState(true);
  const [routeName, setRouteName] = useState("");
  const workflowName = props.workflowName;

  const releasePermProd = useSelector(prodReleasePermissionsSelector).release;
  const approvePermProd = useSelector(prodReleasePermissionsSelector).approve;
  const superAdmin = useSelector((state: RootState) => state.isSuperAdmin.isSuperAdmin);
  const modelMapping_uat = useSelector((state: RootState) => state.releaseData.modelMappings.uatModelMapping );
  const apiConfig_uat = useSelector((state: RootState) => state.releaseData.apiConfig.uatApiConfig );
  const mergerules_uat = useSelector((state: RootState) => state.releaseData.mergeRules.uatMergeRules );

  useEffect(() => {

    const uatStatus = releaseRows.find((x:any) => x.cells.field1 == actionedVersion)?.cells.field4;
    const prodStatus = releaseRows.find((x:any) => x.cells.field1 == actionedVersion)?.cells.field6;
    const prodApprove = releaseRows.find((x:any) => x.id == actionedVersion)?.cells.field6;
    
    setprodDeploy(actionedVersion ? (uatStatus == "Deployed" && (prodStatus == "Draft" || prodStatus == "") ? false : true) : true);
    setprodApproveReject(prodApprove == "Awaiting Approval" ? false : true);

  }, [actionedVersion, releaseRows]);
 
  useEffect(()=>{
    setinsightWorkflow(uatWorkflow.workFlowType);
    setfamilyName(uatWorkflow.family);
    if (uatWorkflow.workFlowType === "Insight")
    {
      setRouteName(uatWorkflow.family);
    }
    else {
       {
        for(var element of uatAppPersona) {
        if (element.subscriptionKey === subscriptionKey)
        {
          var routeName = element.appName.replace(/\s+/g, '').toLowerCase()
          setRouteName(routeName);
          break;
        }
      }
      };
    }
  }, [uatWorkflow]);

  useEffect(() => {
    dispatchApp(getModelMapping_uat({ name: "", id: "" }));
    dispatchApp(getMergeRules_uat(""));
    if (uatWorkflow.workFlowType === "Insight")
    {
      var insightId = getInsightId(uatWorkflow);
    
      dispatchApp(getApiConfig_uat({routeType: "Insight", subsKey: subscriptionKey}));
      if (insightId)
        dispatchApp(getCatalogueConfig_uat(insightId))

    //if (devWorkflow.typeOfMerge != 'SkipMerge') 
    // dispatchApp(getApiConfig_uat({routeType: "Recommendation", subsKey: subscriptionKey}));
    }
    else {
    dispatchApp(getApiConfig_uat({routeType: "Recommendation", subsKey: subscriptionKey}));
    }
  }, [dispatchApp, actionedVersion, workflowId]);

  return (
    <div 
    style={{display:"flex", border:"none", outline:"none", boxShadow:"none", padding:"4px", fontSize:"14px", alignItems:"center", marginRight:"12px", marginLeft:"12px"}}>

      <div> <SuccessNotification successNotif={showSuccessNotif} setsuccesnotif={setShowSuccessNotif} successText = {successText} /> </div>
      <div> <ErrorNotification errorNotif={showErrorNotif} seterrornotif={setShowErrorNotif} errorText = {errorText} /> </div>

      <div>
      <span style={{fontWeight:"700", marginRight:"8px"}}>PROD</span>
      </div>

      <div>
      <CommandBar>
      <Button appearance="command" disabled={prodDeploy || selectedReleaseIds.length != 1}
      onClick={ async() =>
        {
          if (releasePermProd.includes(subscriptionKey) || superAdmin || userSalesRoles.isSpaAdmin || userSalesRoles.isSpaUser) {

          const updatedWorkflow = {...uatWorkflow, status:"Submitted", environment: "prod" };
          dispatchApp(postWorkflowReleaseManagement( { workflow: updatedWorkflow, env: "prod" }));
          
          const propagateRelease = handlePostRelease({workflowId: workflowId , version : actionedVersion , releaseId : releaseId });
          const updatedPropagateRelease = {...propagateRelease, status:"Submitted", environment: "prod" }
          dispatchApp(postReleaseReleaseManagement({payload: updatedPropagateRelease, env:"prod"}));
          dispatch(addRelease({input: updatedPropagateRelease, env:"prod"}));
          dispatch(setReleaseStatus({version: actionedVersion, status: "Submitted", env: "prod"}));

          const propagateConnections =  handlePropagateConnections( {devWorkflow : props.uatWorkflow, devConnections : uatConnections, uatConnections: prodConnections} )
          if(propagateConnections)
          {
            dispatchApp(propagateConnectionReleaseManagement({payload:propagateConnections, env:"prod", subscriptionKey: subscriptionKey}));
            dispatch(addConnection({subskey: subscriptionKey, input: propagateConnections, env:"prod"}));
          }
          
            setprodDeploy(true);
            setShowSuccessNotif(true); setSuccessText("Submitted for Approval");
          
            if(insightWorkflow == "Insight" && uatWorkflow?.family != undefined && uatWorkflow?.family != null && uatWorkflow?.family != "")
          {
            const validateFamily = await dispatchApp(
              validateInsightFamily_prod(uatWorkflow?.family)
            ).unwrap();
            if (!validateFamily.value) {
              setinsightFamilyExists(false);
            }
            else
            {
              setinsightFamilyExists(true);
            }     
          }
          
          }
          else
          {
            setErrorText("You do not have permission to deploy this workflow"); setShowErrorNotif(true);
          }
        }
      }>
        <Icon slot="start" name="rocket"></Icon>
        Deploy
      </Button>
      <Button appearance="command" 
      disabled = {prodApproveReject || selectedReleaseIds.length != 1} 
      onClick= { async() => 
       { 
        if(approvePermProd.includes(subscriptionKey) || superAdmin || userSalesRoles.isSpaAdmin || userSalesRoles.isSpaUser)
        { 
          const hasApprovedList = [];
          hasApprovedList.push(userId);
          const updatedWorkflow = {...uatWorkflow, hasApproved:hasApprovedList, environment: "prod", schedule: {} as Schedule };
          dispatch(patchReleaseWorkflow({input: updatedWorkflow, env: "prod"}));
  
          dispatch(setWorkflowSummaryStatus({workflowId: workflowId, status: "Published"}));
          dispatch(setReleaseWorkflowStatus({status: "Published", env:"prod"}));
  
          dispatch(setReleaseStatus({version: actionedVersion, status: "Published", env: "prod"}));
          const propagateRelease = handlePostRelease({workflowId: workflowId , version : actionedVersion , releaseId : releaseId });
          dispatchApp(postReleaseReleaseManagement({payload: propagateRelease, env:"prod"}));
          
          await dispatchApp(postWorkflowReleaseManagement( { workflow: updatedWorkflow, env: "prod" }));

          const modelmapping = handlePropagateModelMapping({modelMapping_dev: modelMapping_uat, devWorkflow: uatWorkflow});
          if(modelmapping && modelmapping.id)
          {
            dispatchApp(updateModelMapping_prod({payload: modelmapping}));
          }

          const typemapping = handlePropagateTypeMapping({devWorkflow: uatWorkflow});
          if(typemapping)
          {
            dispatchApp(updateTypeMapping_prod({payload: typemapping}));
          }
          const edmSettings = handlePropagateApiConfig({ apiConfig_uat: apiConfig_uat, routeName: routeName, workflow: uatWorkflow });
          if(edmSettings && edmSettings.length > 0)
          {
            if(insightWorkflow && insightWorkflow === "Insight")
          {
            if(insightFamilyExists === false)
            {
              dispatchApp(postInsightFamilyReleaseManagement({family: familyName , env:"prod"}));
            }
           dispatchApp(propagateRoute({ routeType: "Insight", payload: edmSettings[0], env: "prod" }))
            if (catalogueConfig_uat) 
            {
               dispatchApp(updateCatalogueConfig_prod(catalogueConfig_uat))
            }
            // Propagate MCP Configuration from UAT to PROD
            try {
              // Get InsightType from workflow name (same logic as ConnectMCP.tsx)
              const insightType = (uatWorkflow?.config?.workflowName || "").replace(/\s+/g, '');
              if (insightType) {
                const mcpConfig_uat = await getPublishedMCPConfigById(insightType, "uat");
                if (mcpConfig_uat) {
                  await propagateMCPConfig(mcpConfig_uat, "prod");
                }
              }
            } catch (error) {
              console.error("Failed to propagate MCP config:", error);
            }
          }
          if(insightWorkflow == "Recommendation")
          {
            const mergeruleToBePropagated = handleDefaultMergeRulePropagation({devWorkflow: uatWorkflow, mergerules_dev: mergerules_uat, modelMapping_dev:modelMapping_uat, workflowname:workflowName});
            if(mergeruleToBePropagated && mergeruleToBePropagated.mergeRuleId && mergeruleToBePropagated.mergeRuleId != 'undefined')
            {
              dispatchApp(propagateMergeRule_prod({mergeRule: mergeruleToBePropagated}));
            }
            dispatchApp(propagateRoute({routeType: "Recommendation",payload: edmSettings[0], env: "prod"}))
            dispatchApp(propagateRoute({routeType: "Recommendation",payload: edmSettings[1], env: "prod"}))
          }
          }
         
          
            await dispatchApp(publishWorkflowReleaseManagement({workflowId: workflowId , env:"prod"})).then(unwrapResult).then((result)=>{ 
            if(result == true)
            {
              setShowSuccessNotif(true); setSuccessText("PROD Deployment completed")
            }
            else
            {
              setErrorText("PROD deployment failed, Invalid workflow"); setShowErrorNotif(true);
              const updatedWorkflow = {...uatWorkflow, status:"New", environment: "prod" };
              dispatch(patchReleaseWorkflow({input: updatedWorkflow, env: "prod"}));
              dispatchApp(postWorkflowReleaseManagement( { workflow: updatedWorkflow, env: "prod" }));

              dispatch(setWorkflowSummaryStatus({workflowId: workflowId, status: "New"}));
              dispatch(setReleaseWorkflowStatus({status: "New", env:"prod"}));

              dispatch(setReleaseStatus({version: actionedVersion, status: "New", env: "prod"}));
            } 
          }); 
          setprodApproveReject(true);
        }
        else
        {
          setErrorText("You do not have permission to approve this workflow"); setShowErrorNotif(true);
        }}
         }>
        <Icon slot="start" name="accept"></Icon>
        Approve
      </Button>
      <Button appearance="command" disabled = {prodApproveReject || selectedReleaseIds.length != 1} 
      onClick={() => {
         if(approvePermProd.includes(subscriptionKey) || superAdmin || userSalesRoles.isSpaAdmin || userSalesRoles.isSpaUser)
         {
          
          const updatedWorkflow = {...uatWorkflow, status:"New", environment: "prod" };
          dispatch(patchReleaseWorkflow({input: updatedWorkflow, env: "prod"}));
          dispatchApp(postWorkflowReleaseManagement( { workflow: updatedWorkflow, env: "prod" }));

          dispatch(setWorkflowSummaryStatus({workflowId: workflowId, status: "New"}));
          dispatch(setReleaseWorkflowStatus({status: "New", env:"prod"}));

          dispatch(setReleaseStatus({version: actionedVersion, status: "New", env: "prod"}));
          
          setShowSuccessNotif(true); setSuccessText("Workflow Rejected");
          setprodDeploy(false);
         }
         else
         {
           setErrorText("You do not have permission to reject in PROD");  setShowErrorNotif(true);
         }
      }}>
        <Icon slot="start" name="calculatormultiply"></Icon>
        Reject
      </Button>

      
    </CommandBar>
      </div>
    </div>

  );
};
export const ReleaseActionsPROD = withErrorBoundary("Release Actions Prod", ReleaseActionsPRODC);